import { render, staticRenderFns } from "./profile-documents.vue?vue&type=template&id=01c0fda2&scoped=true"
import script from "./profile-documents.vue?vue&type=script&lang=ts"
export * from "./profile-documents.vue?vue&type=script&lang=ts"
import style0 from "./profile-documents.vue?vue&type=style&index=0&id=01c0fda2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c0fda2",
  null
  
)

export default component.exports